import { ProductRelationModalFormWrapper } from '@/app/modules/product-modifier/product-modifier-list/components/product-relation-modal/ProductRelationModalFormWrapper'
import { ProductRelationModalHeader } from '@/app/modules/product-modifier/product-modifier-list/components/product-relation-modal/ProductRelationModalHeader'
import {useEffect} from 'react'
import { SubscriptionCustomerModalHeader } from './SubscriptionCustomerModalHeader'
import { SubscriptionCustomerModalFormWrapper } from './SubscriptionCustomerModalFormWrapper'


const SubscriptionCustomerModal = ()  => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block modal-xl'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered w-100' style={{maxWidth: '1400px'}}>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <SubscriptionCustomerModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y my-7'>
              <SubscriptionCustomerModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {SubscriptionCustomerModal}
